//@ts-nocheck // FIXME: fix types
import { isFunction } from "@/utils/is-function";

/**
 * `instanceof TouchEvent` throws on desktop Firefox, where the constructor
 * is not defined (FRONTEND-D9N). Guard the identifier before using it.
 */
export function isTouchEvent(
  event: MouseEvent | TouchEvent
): event is TouchEvent {
  return typeof TouchEvent !== "undefined" && event instanceof TouchEvent;
}

export function pointerPagePosition(event: MouseEvent | TouchEvent): {
  pageX: number;
  pageY: number;
} {
  if (isTouchEvent(event)) {
    const touch = event.touches[0];
    return { pageX: touch.pageX, pageY: touch.pageY };
  }
  return { pageX: event.pageX, pageY: event.pageY };
}

export function snapToGrid(
  grid: [x: number, y: number],
  pendingX: number,
  pendingY: number,
  scale: number
): [x: number, y: number] {
  const [scaleX, scaleY] = typeof scale === "number" ? [scale, scale] : scale;
  const x = Math.round(pendingX / scaleX / grid[0]) * grid[0];
  const y = Math.round(pendingY / scaleY / grid[1]) * grid[1];
  return [x, y];
}

export function computeWidth(
  parentWidth: number,
  left: number,
  right: number
): number {
  return parentWidth - left - right;
}

export function computeHeight(
  parentHeight: number,
  top: number,
  bottom: number
): number {
  return parentHeight - top - bottom;
}

export function restrictToBounds(
  value: number,
  min: null | number,
  max: null | number
): number {
  if (min !== null && value < min) {
    return min;
  }

  if (max !== null && max < value) {
    return max;
  }

  return value;
}

export function matchesSelectorToParentElements(el, selector, baseNode) {
  let node = el;

  const matchesSelectorFunc = [
    "matches",
    "webkitMatchesSelector",
    "mozMatchesSelector",
    "msMatchesSelector",
    "oMatchesSelector",
  ].find((func) => isFunction(node[func]));

  if (!isFunction(node[matchesSelectorFunc])) return false;

  do {
    if (node[matchesSelectorFunc](selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

export function getComputedSize($el) {
  const style = window.getComputedStyle($el);

  return [
    parseFloat(style.getPropertyValue("width"), 10),
    parseFloat(style.getPropertyValue("height"), 10),
  ];
}

export function addEvent(el, event, handler) {
  if (!el) {
    return;
  }
  if (el.attachEvent) {
    el.attachEvent("on" + event, handler);
  } else if (el.addEventListener) {
    el.addEventListener(event, handler, true);
  } else {
    el["on" + event] = handler;
  }
}

export function removeEvent(el, event, handler) {
  if (!el) {
    return;
  }
  if (el.detachEvent) {
    el.detachEvent("on" + event, handler);
  } else if (el.removeEventListener) {
    el.removeEventListener(event, handler, true);
  } else {
    el["on" + event] = null;
  }
}
